import { Route, Routes, Navigate } from "react-router-dom";
import NotFound from "../components/common/page404";
import ReportsLogin from "../components/pages/login";
import { ProtectedRoute } from "./ProtectedRoute";
import { Page } from "./config";
import ReportsLayout from "../components/pages/reports/ReportsLayout";
import InventorySummary from "../components/pages/reports/InventorySummary";
import InventoryDetails from "../components/pages/reports/InventoryDetails";
import InventoryTagEpcisHistory from "../components/pages/reports/InventoryTagEpcisHistory";
import TransferReport from "../components/pages/reports/TransferReport";
import ReceiveReport from "../components/pages/reports/ReceiveReport";
import SiteReceiveReport from "../components/pages/reports/SiteReceiveReport";
import TrackTraceReport from "../components/pages/reports/TrackTraceReport";
import EnablementDetails from "../components/pages/reports/EnablementDetails";
import { AsnLineItemsDetails } from "../components/pages/reports/AsnLineItemsDetails";
import DiEnablementReport from "../components/pages/reports/DiEnablementReport";
import TNTEnablementReport from "../components/pages/reports/TNTEnablementReport";

const UIRoutes = () => {
  return (
    <Routes>
      <Route path={Page.LOGIN} element={<ReportsLogin />} />
      <Route
        path={Page.HOME}
        element={
          <ProtectedRoute>
            <Navigate to={Page.REPORTS_ENABLEMENT} replace />
          </ProtectedRoute>
        }
      />

      {/* Reports routes */}
      <Route
        path={Page.REPORTS}
        element={
          <ProtectedRoute>
            <ReportsLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to={Page.REPORTS_ENABLEMENT} replace />} />
        <Route path="enablement" element={<DiEnablementReport />} />

        <Route path="tnt-current-status" element={<TNTEnablementReport />} />

        <Route path="di/details" element={<EnablementDetails />} />

        <Route path="inventory" element={<InventorySummary />} />
        <Route path="inventory/details" element={<InventoryDetails />} />
        <Route path="inventory/tag/epcis" element={<InventoryTagEpcisHistory />} />

        <Route path="transfer" element={<TransferReport />} />
        <Route path="transfer/details" element={<AsnLineItemsDetails reportType="transfer" />} />

        <Route path="receive" element={<ReceiveReport />} />
        <Route path="receive/details" element={<SiteReceiveReport />} />
        <Route path="receive/line-items" element={<InventoryDetails tagEpcisRoute={Page.REPORTS_RECEIVE_TAG_EPCIS} requireSku={false} />} />
        <Route path="receive/tag/epcis" element={<InventoryTagEpcisHistory />} />

        <Route path="trackntrace" element={<TrackTraceReport />} />
        <Route path="asn/details" element={<AsnLineItemsDetails reportType="transfer" />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default UIRoutes;